import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellTrajectorySizeM from './IconWellTrajectory_size_m';

const props: CreateIconArguments = {
  l: IconWellTrajectorySizeM,
  m: IconWellTrajectorySizeM,
  s: IconWellTrajectorySizeM,
  xs: IconWellTrajectorySizeM,
  name: 'IconWellTrajectory',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
